module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av399-cf1f64209b03d1e7f4308f647223e677.jpg";